import { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  LinearProgress,
  ThemeProvider,
  createTheme,
  Autocomplete,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/store";
import { getSpecialityGraphData } from "../../../redux/mis/misReducer";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import SelectComponent from "../../../components/forms/selectComponent";

const theme = createTheme({
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: "#eeeeee00",
        },
        bar: {
          background: "linear-gradient(to right, #F1C3C9 30%, #EBA5AF 70%)",
        },
      },
    },
  },
});

const specialityList = [
  { label: "All speciality", value: "all" },
  { label: "Top 5 speciality", value: 5 },
  { label: "Top 10 speciality", value: 10 },
];

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 22,
  borderRadius: 0,
}));

function SpecialityList({
  country,
  state,
  district,
  taluk,
  hobli,
  filterApplyToggle,
}: any) {
  const dispatch = useAppDispatch();
  const SpecialityData = useSelector(
    (data: any) => data.getSpecialityGraphData
  );
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [specialityGraphData, setSpecialityGraphData] = useState<any>([]);
  const [selectedValue, setSelectedValue] = useState("all");
  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
  };

  let highestPercentage = 0;

  specialityGraphData?.data?.specialityHospitalsCount?.forEach(
    (region: any) => {
      if (region.percentage > highestPercentage) {
        highestPercentage = region.percentage;
      }
    }
  );

  const casesNoShow =
    specialityGraphData?.data?.specialityHospitalsCount.length;

  useEffect(() => {
    // for all hospiatl api call handling response
    if (SpecialityData?.status === "success") {
      setErrorMessage("");
      setSpecialityGraphData(SpecialityData?.data ?? []);
    } else if (SpecialityData?.status === "failed") {
      setErrorMessage("Something went Wrong");
    }
  }, [SpecialityData]);

  useEffect(() => {
    dispatch(
      getSpecialityGraphData({
        country: country,
        state: state,
        district: district,
        taluk: taluk,
        hobli: hobli,
        serviceType: "",
      })
    );
  }, [filterApplyToggle]);

  return (
    <div className="p-6 bg-white shadow-sm1 rounded-lg">
      {SpecialityData.isLoading ? (
        <div className="flex justify-center py-5">
          <LoadingSpinner />
        </div>
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={6}>
            <span className="text-18 font-medium text-primary">Speciality</span>

            <div>
              <span className="text-14 font-[400] text-secondary">
                Total Specialties:
              </span>
              <span className="text-14 font-[700] text-primary pl-1">
                {specialityGraphData?.data?.specialitiesCount.toLocaleString(
                  "en-IN"
                )}
              </span>
            </div>

            <hr
              style={{
                marginBottom: "8px",
                marginTop: "8px",
                background: "#F2F4F7",
                height: "1.4px",
              }}
            />

            <div style={{ display: "flex", marginTop: "8px" }}>
              <div>
                <span className="text-14 font-[400] text-secondary">
                  No. of Active Hospitals :
                </span>
                <span className="text-14 font-[700] text-primary pl-1">
                  {specialityGraphData?.data?.activeHospitalsCount?.toLocaleString(
                    "en-IN"
                  )}
                </span>
              </div>

              <div>
                <span className="text-14 font-[400] text-secondary ml-[14px]">
                  Single :
                </span>
                <span className="text-14 font-[700] text-primary pl-1">
                  {specialityGraphData?.data?.singleSpecialityCount?.toLocaleString(
                    "en-IN"
                  )}
                </span>
              </div>

              <div>
                <span className="text-14 font-[400] text-secondary ml-[14px]">
                  Multiple :
                </span>
                <span className="text-14 font-[700] text-primary pl-1">
                  {specialityGraphData?.data?.multiSpecialityCount?.toLocaleString(
                    "en-IN"
                  )}
                </span>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            style={{ display: "flex", justifyContent: "end" }}
          >
            <SelectComponent
              label="Select"
              id="status"
              value={selectedValue}
              onChange={handleChange}
              options={specialityList}
            />
          </Grid>
          {specialityGraphData?.data?.specialityHospitalsCount.length > 0 ? (
            <Grid item xs={12} sm={12} md={12}>
              {specialityGraphData?.data?.specialityHospitalsCount
                ?.slice(
                  0,
                  selectedValue === "all"
                    ? casesNoShow
                    : parseInt(selectedValue)
                )
                .map((item: any, index: any) => {
                  return (
                    <>
                      <ThemeProvider theme={theme}>
                        {" "}
                        <div key={index}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={1.8}>
                              <span
                                style={{
                                  color: "#212121",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                }}
                              >
                                {item.name}
                              </span>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9.5}>
                              <span
                                style={{
                                  zIndex: 1,
                                  position: "relative",
                                  color: "#212121",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                }}
                              >
                                {item.totalCount?.toLocaleString("en-IN")}
                              </span>
                              <BorderLinearProgress
                                style={{
                                  right: "6px",
                                  position: "relative",
                                  bottom: 22,
                                  width: "100%",
                                }}
                                variant="determinate"
                                value={
                                  (item.percentage / highestPercentage) * 100
                                }
                              />
                            </Grid>
                            <Grid
                              style={{ display: "flex", justifyContent: "end" }}
                              item
                              xs={12}
                              sm={12}
                              md={0.7}
                            >
                              <span
                                style={{
                                  color: "#212121",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                }}
                              >
                                {item.percentage}%
                              </span>
                            </Grid>
                          </Grid>
                        </div>
                      </ThemeProvider>
                    </>
                  );
                })}
            </Grid>
          ) : (
            <Grid item xs={12} sm={12} md={12}>
              <div className="flex justify-center">
                <span className="text-18 font-medium text-primary">
                  No Data Found
                </span>
              </div>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  );
}

export default SpecialityList;
